import { Instagram, Youtube, Music, ArrowUpRight, QrCode, Download } from "lucide-react";
import { BOOK_URL, LOGO_URL } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-black text-white px-5 md:px-8 py-14"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="LaGigaFam"
              className="h-16 w-16 rounded-2xl object-contain bg-black p-1"
            />
            <div>
              <p className="text-[11px] font-extrabold uppercase tracking-tight text-pink-400">
                LAGIGAFAM
              </p>
              <p className="font-display text-2xl font-black uppercase tracking-tight">
                BBL Natural Sculpt
              </p>
            </div>
          </div>
          <p className="mt-5 text-white/60 max-w-sm leading-relaxed">
            Institut de sport, bien-être et BBL Natural Sculpt — by Perle Lama.
            Énergie tropicale, résultats bien réels.
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs font-bold uppercase tracking-widest text-pink-400 mb-4">
            Navigation
          </p>
          <ul className="space-y-2 text-white/80">
            <li>
              <a href="#services" className="hover:text-pink-400">
                Services
              </a>
            </li>
            <li>
              <a href="#precommandes" className="hover:text-pink-400">
                Précommandes
              </a>
            </li>
            <li>
              <a href="#a-propos" className="hover:text-pink-400">
                À propos
              </a>
            </li>
            <li>
              <a href="#temoignages" className="hover:text-pink-400">
                Témoignages
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-pink-400">
                Contact
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-widest text-pink-400 mb-4">
            Réserve maintenant
          </p>
          <a
            href={BOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-book-button"
            className="inline-flex items-center gap-2 bg-pink-600 hover:bg-pink-700 text-white px-6 h-12 rounded-full font-bold transition"
          >
            Prendre rendez-vous <ArrowUpRight size={16} />
          </a>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="#"
              aria-label="Instagram"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-pink-600 flex items-center justify-center transition"
            >
              <Instagram size={18} />
            </a>
            <a
              href="#"
              aria-label="Youtube"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-pink-600 flex items-center justify-center transition"
            >
              <Youtube size={18} />
            </a>
            <a
              href="#"
              aria-label="TRACE"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-pink-600 flex items-center justify-center transition"
            >
              <Music size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-widest text-pink-400 mb-4 flex items-center gap-2">
            <QrCode size={14} /> Scanne & partage
          </p>
          <div className="bg-white rounded-2xl p-3 w-fit shadow-xl">
            <img
              src="/assets/qr-lagigafam.png"
              alt="QR Code lagigafam.com"
              data-testid="footer-qr-code"
              className="w-36 h-auto block"
            />
          </div>
          <a
            href="/assets/qr-lagigafam.png"
            download="qr-lagigafam.png"
            data-testid="footer-qr-download"
            className="mt-3 inline-flex items-center gap-2 text-xs font-bold text-pink-400 hover:text-white transition"
          >
            <Download size={14} /> Télécharger le QR
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} LaGigaFam by Perle Lama. Tous droits réservés.</p>
        <p>lagigafam@gmail.com • Made with 💖 in the tropics</p>
      </div>
    </footer>
  );
}
